// extracted by mini-css-extract-plugin
export default {"ldshourglass":"loader_ldshourglass__z0Ach"};